"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_recaptcha_v3_1 = require("react-recaptcha-v3");
var CaptchaGeneratorV3_config_1 = require("./CaptchaGeneratorV3.config");
/**
 *
 * <style>
 * #CaptchaGeneratorV3-container ul[class*="rsg--list-"]{margin:20px 0;padding:0;}
 * #CaptchaGeneratorV3-container li[class*="rsg--li-"]{display:inline;border:1px solid #ccc;border-radius:12px;}
 * #CaptchaGeneratorV3-container li[class*="rsg--li-"]{background:#d12127;padding:4px 8px;color:#fff;margin-right:16px;}
 * #CaptchaGeneratorV3-container li[class*="rsg--li-"]:last-child{background:#007a3e;}
 * #CaptchaGeneratorV3-container li[class*="rsg--li-"] p{display:inline;color:#fff;}
 * </style>
 * <ul style="">
 * <li style="">Phase - Beta Unreleased</li>
 * <li style="">Approval - Pending</li>
 * </ul>
 *
 * @visibleName CaptchaGeneratorV3
 */
var CaptchaGenerator = /** @class */ (function (_super) {
    __extends(CaptchaGenerator, _super);
    function CaptchaGenerator(props) {
        var _this = _super.call(this, props) || this;
        _this.sendMessage = function () {
            _this.reCaptcha.execute();
        };
        _this.verifyCallback = function (recaptchaToken) {
            // Here you will get the final recaptchaToken!!!
            var scoreUrl = CaptchaGeneratorV3_config_1.CaptchaConfigV3.scoreUrl;
            if (_this.props.data.callExecute) {
                var reqObj = {
                    "captchaResponse": recaptchaToken,
                };
                fetch(CaptchaGeneratorV3_config_1.CaptchaConfigV3.scoreUrl, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                    },
                    body: JSON.stringify(reqObj),
                })
                    .then(function (response) { return response.json(); })
                    .then(function (resObj) {
                    var _a;
                    if ((_a = _this.props.events) === null || _a === void 0 ? void 0 : _a.verifyCaptcha) {
                        if (resObj.content.success && resObj.content.score > 0.5) {
                            _this.props.events.verifyCaptcha(resObj.content.success);
                        }
                        else {
                            _this.props.events.verifyCaptcha(false);
                        }
                    }
                })
                    .catch(function (error) {
                    var _a;
                    if ((_a = _this.props.events) === null || _a === void 0 ? void 0 : _a.verifyCaptcha) {
                        _this.props.events.verifyCaptcha(false);
                    }
                });
            }
        };
        _this.reCaptcha = {};
        _this.loadHandler = _this.loadHandler.bind(_this);
        _this.unloadRecaptchav3 = _this.unloadRecaptchav3.bind(_this);
        return _this;
    }
    CaptchaGenerator.prototype.componentDidMount = function () {
        if (document.readyState === 'complete') {
            this.loadHandler();
        }
        else {
            window.addEventListener("load", this.loadHandler);
        }
    };
    CaptchaGenerator.prototype.componentDidUpdate = function () {
        if (this.props.data.callExecute) {
            this.sendMessage();
        }
    };
    CaptchaGenerator.prototype.componentWillUnmount = function () {
        this.unloadRecaptchav3();
        window.removeEventListener("load", this.loadHandler);
    };
    CaptchaGenerator.prototype.loadHandler = function () {
        react_recaptcha_v3_1.loadReCaptcha(CaptchaGeneratorV3_config_1.CaptchaConfigV3.attSiteKeys.siteKeyV3);
    };
    CaptchaGenerator.prototype.unloadRecaptchav3 = function () {
        var nodeBadge = document.querySelector('.grecaptcha-badge');
        if (nodeBadge && nodeBadge.parentNode) {
            document.body.removeChild(nodeBadge.parentNode);
        }
        var scriptSelector = 'script[src=\'https://www.google.com/recaptcha/api.js?render=' +
            CaptchaGeneratorV3_config_1.CaptchaConfigV3.attSiteKeys.siteKeyV3 + '\']';
        var script = document.querySelector(scriptSelector);
        if (script) {
            script.remove();
        }
    };
    ;
    CaptchaGenerator.prototype.render = function () {
        var _this = this;
        var actionName = this.props.data && this.props.data.actionName ?
            this.props.data.actionName : "UserAction";
        return (React.createElement(react_recaptcha_v3_1.ReCaptcha, { ref: function (ref) { return _this.reCaptcha = ref; }, sitekey: CaptchaGeneratorV3_config_1.CaptchaConfigV3.attSiteKeys.siteKeyV3, action: actionName, verifyCallback: this.verifyCallback }));
    };
    return CaptchaGenerator;
}(React.Component));
exports.default = CaptchaGenerator;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/CaptchaGeneratorV3/CaptchaGeneratorV3.js
// module id = 1749
// module chunks = 8